import * as React from 'react';

import Layout from '../../components/layout';
import SEO from '../../components/seo';

const RichnyiPlanPidvyshchenniaKvalifikatsiiPedahohichnykhPratsivnykiv_2024Page = () => {
  return (
    <Layout>
      <article>
        <h2>
          РІЧНИЙ ПЛАН <br />
          підвищення кваліфікації педагогічних працівників закладу на 2024 рік <br />
          КЗ &quot;ЗДО «Лісова казка» ВМР&quot;
        </h2>

        <div className="top-spacing-big scrollable-table">
          <table>
            <thead>
              <tr>
                <th>№ з/п</th>
                <th>ПІБ педагогічних працівників</th>
                <th>Тема (напрям, найменування)</th>
                <th>Суб&apos;єкт підвищення кваліфікації</th>
                <th>Обсяг (тривалість)</th>
                <th>Вид навчання</th>
                <th>Форма навчання</th>
                <th>Строки(графік)</th>
                <th>Вартість (або примітка про самофінансування чи безоплатність)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1.</td>
                <td>Овчар Інна Олександрівна</td>
                <td>Вихователі ЗДО (за освітньо-кваліфікаційним рівнем магістра або спеціаліста</td>
                <td>КЗВО «ВАБО»</td>
                <td>120 год</td>
                <td>Фахові</td>
                <td>Очно - дистанційна</td>
                <td></td>
                <td>Безоплатні</td>
              </tr>
              <tr>
                <td>2.</td>
                <td>ПаламарчукВіра Григорівна</td>
                <td>Вихователі ЗДО (за освітньо-кваліфікаційним рівнем магістра або спеціаліста</td>
                <td>КЗВО «ВАБО»</td>
                <td>120 год</td>
                <td>Фахові</td>
                <td>Очно - дистанційна</td>
                <td></td>
                <td>Безоплатні</td>
              </tr>
              <tr>
                <td>3.</td>
                <td>Ваколюк Вікторія Вікторівна</td>
                <td>Директор ЗДО зі стажем роботи до 5 років</td>
                <td>КЗВО «ВАБО»</td>
                <td>120 год</td>
                <td>Фахові</td>
                <td>Очно - дистанційна</td>
                <td></td>
                <td>Безоплатні</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="grid top-spacing-small">
          <div className="grid__item teacher">Голова педагогічної ради</div>
          <div className="grid__item teacher">Вікторія ВАКОЛЮК</div>
        </div>
      </article>
    </Layout>
  );
};

export default RichnyiPlanPidvyshchenniaKvalifikatsiiPedahohichnykhPratsivnykiv_2024Page;

export const Head = () => <SEO title="Річний план підвищення кваліфікації педагогічних працівників 2024" />;
